import type { LocalStore } from "@onchainreps/storage";
import { BotGame } from "./BotGame";
import { MistakeTrainer } from "./MistakeTrainer";
import { OpeningsTrainer } from "./OpeningsTrainer";
import { TacticsTrainer } from "./TacticsTrainer";
import { RepertoireBuilder } from "./RepertoireBuilder";
import { RepertoireTrainer } from "./RepertoireTrainer";
import type { StoredRepertoire } from "@onchainreps/storage";
import { useState } from "react";

export type TrainerMode = "openings" | "tactics" | "mistakes" | "play" | "repertoire";

interface TrainerHomeProps {
  store: LocalStore | null;
  mode: TrainerMode;
  onMode: (mode: TrainerMode) => void;
}

export function TrainerHome({ store, mode, onMode }: TrainerHomeProps) {
  const [repertoireLines, setRepertoireLines] = useState<StoredRepertoire[]>([]);
  const [training, setTraining] = useState(false);

  if (mode === "repertoire" && training) {
    return (
      <div className="trainer">
        <RepertoireTrainer
          lines={repertoireLines}
          onExit={() => {
            setTraining(false);
            onMode("repertoire");
          }}
        />
      </div>
    );
  }

  return (
    <div className="trainer">
      <div className="segmented segmented--wide" role="tablist">
        {(
          [
            ["openings", "Openings"],
            ["tactics", "Tactics"],
            ["mistakes", "Mistakes"],
            ["play", "Play"],
            ["repertoire", "Repertoire"],
          ] as Array<[TrainerMode, string]>
        ).map(([id, label]) => (
          <button
            key={id}
            role="tab"
            aria-selected={mode === id}
            onClick={() => onMode(id)}
          >
            {label}
          </button>
        ))}
      </div>

      {mode === "openings" ? <OpeningsTrainer store={store} /> : null}
      {mode === "tactics" ? <TacticsTrainer store={store} /> : null}
      {mode === "mistakes" ? <MistakeTrainer store={store} /> : null}
      {mode === "play" ? <BotGame store={store} /> : null}
      {mode === "repertoire" ? (
        <RepertoireBuilder
          store={store}
          onTrain={(lines) => {
            setRepertoireLines(lines);
            setTraining(true);
          }}
        />
      ) : null}
    </div>
  );
}
